import { Link } from "react-router-dom";
/* eslint-disable-next-line no-unused-vars -- motion.div used in JSX (member expression not tracked by no-unused-vars) */
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { emptyFilters } from "../data/filters";

const CATEGORIES = [
  "Books & Notes",
  "Electronics",
  "Clothing",
  "Furniture",
  "Sports & Fitness",
  "Games",
];

function CategoryLink({ category, children }) {
  const onClick = () => {
    const filters = { ...emptyFilters, category };
    sessionStorage.setItem("homeFilters", JSON.stringify(filters));
    window.dispatchEvent(new CustomEvent("navbar-filter-change", { detail: { filters } }));
  };
  return (
    <Link to="/browse" onClick={onClick} className={columnLink}>
      {children}
    </Link>
  );
}

const SOCIALS = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/unih.aul/",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
    colorIcon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="url(#insta-grad)">
        <defs>
          <linearGradient id="insta-grad" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#F58529" />
            <stop offset="50%" stopColor="#DD2A7B" />
            <stop offset="100%" stopColor="#8134AF" />
          </linearGradient>
        </defs>
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    label: "WhatsApp",
    href: "#",
    icon: (
      <svg width="20" height="20" viewBox="0 0 448 512" fill="currentColor">
        <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
      </svg>
    ),
    colorIcon: (
      <svg width="20" height="20" viewBox="0 0 448 512" fill="#25D366">
        <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
      </svg>
    ),
  },
  {
    label: "Email",
    href: "mailto:support.unihaul@gmail.com",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z" />
      </svg>
    ),
    colorIcon: (
      <svg width="20" height="20" viewBox="52 42 88 66">
        <path fill="#4285f4" d="M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6" />
        <path fill="#34a853" d="M120 108h14c3.32 0 6-2.69 6-6V59l-20 15" />
        <path fill="#fbbc04" d="M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2" />
        <path fill="#ea4335" d="M72 74V48l24 18 24-18v26L96 92" />
        <path fill="#c5221f" d="M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2" />
      </svg>
    ),
  },
];

const columnHeading = "font-brand text-[1.3rem] text-amber-600";
const columnLink = "footer-link block text-[0.85rem] text-black dark:text-white py-1";

const container = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.5 } },
};

const lineItem = {
  hidden: { scaleX: 0, opacity: 0 },
  show: { scaleX: 1, opacity: 1, transition: { duration: 1.2, ease: [0.22, 1, 0.36, 1] } },
};

const textItem = {
  hidden: { y: "110%", opacity: 0 },
  show: {
    y: "0%",
    opacity: 1,
    transition: { duration: 0.3, ease: [0.16, 1, 0.3, 1] },
  },
};

const slowItem = {
  hidden: { y: "110%", opacity: 0 },
  show: {
    y: "0%",
    opacity: 1,
    transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] },
  },
};

const headingItem = {
  hidden: { y: "110%", opacity: 0 },
  show: {
    y: "0%",
    opacity: 1,
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
  },
};

const logoItem = {
  hidden: { y: "110%", opacity: 0, scale: 0.97 },
  show: {
    y: "0%",
    opacity: 1,
    scale: 1,
    transition: { duration: 1.4, ease: [0.16, 1, 0.3, 1] },
  },
};

function columnGroup(delay = 0, stagger = 0.1) {
  return {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };
}

function Reveal({ children, className, variant = textItem }) {
  return (
    <div className={`overflow-hidden ${className || ""}`}>
      <motion.div variants={variant} style={{ willChange: "transform" }}>{children}</motion.div>
    </div>
  );
}

export default function Footer() {
  const [revealed, setRevealed] = useState(false);
  const { pathname } = useLocation();

  const [prevPath, setPrevPath] = useState(pathname);
  if (prevPath !== pathname) {
    setPrevPath(pathname);
    setRevealed(false);
  }

  useEffect(() => {
    const check = () => {
      const doc = document.documentElement;
      const nearBottom =
        window.scrollY + window.innerHeight >= doc.scrollHeight - 120;
      if (nearBottom && window.scrollY > 50) {
        setRevealed(true);
        window.removeEventListener("scroll", check);
        window.removeEventListener("resize", check);
      }
    };
    check();
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [pathname]);

  return (
    <footer className="hidden md:block bg-surface">
      <div className="max-w-6xl mx-auto px-8 pt-8 pb-0">
        <motion.div
          variants={container}
          initial="hidden"
          animate={revealed ? "show" : "hidden"}
        >
          <motion.div variants={lineItem} className="h-px bg-black dark:bg-white origin-left" />

          <div className="flex justify-between gap-16 mt-8">
            <motion.div variants={columnGroup(0.1)} className="min-w-44 mr-24">
              <Reveal variant={headingItem}><h3 className={`${columnHeading} mb-4`}>Contact</h3></Reveal>
              <Reveal><p className={columnLink}>support.unihaul@gmail.com</p></Reveal>
              <Reveal><p className={columnLink}>+91 90000 00000</p></Reveal>
            </motion.div>

            <motion.div variants={columnGroup(0.7)} className="ml-[44px]">
              <Reveal variant={headingItem}><h3 className={`${columnHeading} mb-4`}>Shop By</h3></Reveal>
              {CATEGORIES.map((c) => (
                <Reveal key={c}><CategoryLink category={c}>{c}</CategoryLink></Reveal>
              ))}
            </motion.div>

            <motion.div variants={columnGroup(1.7)}>
              <Reveal variant={headingItem}><h3 className={`${columnHeading} mb-4`}>Browse</h3></Reveal>
              <Reveal><Link to="/browse" className={columnLink}>All items</Link></Reveal>
              <Reveal><Link to="/sellers" className={columnLink}>Find sellers</Link></Reveal>
              <Reveal><Link to="/post" className={columnLink}>Post an item</Link></Reveal>
              <Reveal><Link to="/watching" className={columnLink}>Watching</Link></Reveal>
              <Reveal><Link to="/cart" className={columnLink}>Cart</Link></Reveal>
            </motion.div>

            <motion.div variants={columnGroup(2.6)}>
              <Reveal variant={headingItem}><h3 className={`${columnHeading} mb-4`}>Help</h3></Reveal>
              <Reveal><Link to="/settings" className={columnLink}>Account settings</Link></Reveal>
              <Reveal><Link to="/orders" className={columnLink}>Orders</Link></Reveal>
              <Reveal><Link to="/transactions" className={columnLink}>Transactions</Link></Reveal>
              <Reveal><Link to="/dashboard" className={columnLink}>Dashboard</Link></Reveal>
              <Reveal><Link to="/login" className={columnLink}>Sign in</Link></Reveal>
            </motion.div>
          </div>

          <motion.div variants={columnGroup(3.2, 0.5)} className="relative mt-14 pt-6 pb-0 flex items-center justify-center">
            <Reveal variant={slowItem} className="absolute left-0 flex items-center gap-3">
              <div className="flex items-center gap-6">
                {SOCIALS.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    aria-label={s.label}
                    title={s.label}
                    className="social-icon relative inline-flex items-center justify-center text-black dark:text-white"
                  >
                    {s.icon}
                    <span className="social-fill">{s.colorIcon}</span>
                  </a>
                ))}
              </div>
            </Reveal>
            <Reveal variant={slowItem} className="absolute right-0 flex items-center gap-4 md:gap-8">
              <div className="flex flex-col sm:flex-row sm:items-center gap-4 md:gap-8">
                <Link to="/terms" className="footer-link font-brand text-[1rem] text-black dark:text-white">Terms &amp; Conditions</Link>
                <Link to="/privacy" className="footer-link font-brand text-[1rem] text-black dark:text-white">Privacy Policy</Link>
              </div>
            </Reveal>
            <Reveal variant={logoItem}>
              <Link to="/browse" className="block text-[3rem] font-bold text-black dark:text-white tracking-tight px-2 py-1" style={{ fontFamily: "'Brafesuit', var(--font-sans)", letterSpacing: '0.04em' }}>
                <span className="text-amber-600 dark:text-white">UniHaul</span><span className="text-accent">.</span>
              </Link>
            </Reveal>
          </motion.div>
        </motion.div>
      </div>
    </footer>
  );
}
